import { type ElementPosition, getCoordinates } from 'modules/ai_voice/lib/dom'

declare global {
  interface Window {
    cursor?: HTMLElement
  }
}

export function getCursor(): HTMLElement {
  if (!window.cursor) {
    const cursor = document.createElement('div')
    cursor.style.cssText = `
      position: fixed;
      width: 24px;
      height: 24px;
      background: rgba(255, 53, 94, 0.8);
      border: 2px solid rgba(255, 53, 94);
      border-radius: 50%;
      z-index: 2147483647;
      pointer-events: none;
      left: calc(50vw - 12px);
      top: calc(50vh - 12px);
      box-shadow: 0 0 10px rgba(255, 53, 94, 0.5);
    `
    document.body.appendChild(cursor)
    window.cursor = cursor
  }
  return window.cursor
}

export async function animateCursorMove(
  element: HTMLElement,
  position: ElementPosition = 'center',
  speed = 10
): Promise<void> {
  const targetPos = getCoordinates(element, position)

  const cursor = getCursor()
  const prevPos = getCoordinates(cursor)

  const distance = Math.sqrt((targetPos.x - prevPos.x) ** 2 + (targetPos.y - prevPos.y) ** 2)
  const duration = Math.pow(distance, 0.25) / speed

  cursor.style.transition = `left ${duration}s cubic-bezier(.25,1,.5,1), top ${duration}s cubic-bezier(.25,1,.5,1)`
  cursor.style.left = `${targetPos.x - 12}px`
  cursor.style.top = `${targetPos.y - 12}px`

  await new Promise<void>((resolve) => setTimeout(resolve, duration * 1000))
}

export async function animateCursorClick(duration = 200): Promise<void> {
  const cursor = getCursor()
  await cursor.animate(
    [
      { transform: 'scale(1)', opacity: 1 },
      { transform: 'scale(0.85)', opacity: 0.8 },
      { transform: 'scale(1)', opacity: 1 },
    ],
    {
      duration,
      easing: 'ease-out',
    }
  ).finished
}

export function removeCursor(): void {
  if (window.cursor) {
    window.cursor.remove()
    delete window.cursor
  }
}
